import React from 'react';
import { OptimizedImage } from './OptimizedImage';

function getCredentialSizeClass(name) {
  const normalized = String(name || '').toLowerCase();

  if (normalized.includes('cranfield')) {
    return 'profile-credential--cranfield';
  }

  if (normalized.includes('nottingham')) {
    return 'profile-credential--nottingham';
  }

  if (normalized.includes('aws') || normalized.includes('professional services') || normalized.includes('proserve')) {
    return 'profile-credential--aws-proserve';
  }

  return '';
}

export function TeamCredential({ credential }) {
  const logoSrc = credential.logo || credential.image;
  const name = credential.name || '';
  const label = credential.note && name ? `${name} - ${credential.note}` : name || credential.note || '';
  const sizeClass = getCredentialSizeClass(name);

  if (!logoSrc && !name) {
    return null;
  }

  return (
    <div className={`profile-credential ${sizeClass}`.trim()} aria-label={label} title={label}>
      {logoSrc ? (
        <>
          <OptimizedImage
            src={logoSrc}
            alt={name}
            className={`profile-credential-logo ${sizeClass ? `${sizeClass}__logo` : ''}`.trim()}
            fit='contain'
            sizes='320px'
          />
          {credential.showName ? <span className='profile-credential-text'>{name}</span> : null}
        </>
      ) : (
        <span className='profile-credential-text'>{name}</span>
      )}
      {credential.note ? <span className='profile-credential-note'>{credential.note}</span> : null}
    </div>
  );
}

export default TeamCredential;
